// extracted by mini-css-extract-plugin
var _1 = "VAJIna88";
var _2 = "DC69tKie";
var _3 = "J7Ixgk1z";
export { _1 as "active", _2 as "switcher", _3 as "switcherInput" }
